<template>
  <div>
    <div v-if="data.length" class="table">
      <div class="app-container table__container">
        <div class="table__header">
          <div class="table__value table__value_id">ID</div>
          <div class="table__value table__value_visits">Просмотры</div>
          <div class="table__value table__value_cart">Корзина</div>
          <div class="table__value table__value_purchase">Покупка</div>
        </div>
        <div class="table__body">
          <div v-for="product in data" class="table__value-item">
            <div class="table__value table__value_id">{{ product.product_id }}</div>
            <div class="table__value table__value_visits">{{ product.visits }} </div>
            <div class="table__value table__value_cart">{{ product.cart }} ({{ getConversion(product.visits, product.cart, 5) }})</div>
            <div class="table__value table__value_purchase">{{ product.purchase }} ({{ getConversion(product.cart, product.purchase, 5) }})</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="! data.length" class="">Информация отсутствует</div>
  </div>
</template>

<script>
export default {
  name: 'conversion-product-table',
  props: {
    data: {
      type: Object,
      require: true,
    }
  },
  methods: {
    getConversion(a, b, i) {
      if (a == 0 && b == 0) {
        return '0%';
      }

      if (b > a) {
        return '∞'
      }

      return `${(b / (a / 100)).toFixed(i || 2)}%`
    }
  }
}
</script>

<style lang="scss">
.table {
  &__header {
    display: flex;
    border-bottom: 1px solid var(--color-border);
    font-weight: 600;
    font-size: 14px;
  }
  &__body {
    display: flex;
    flex-direction: column;
  }
  &__value-item {
    display: flex;

    &:not(:last-child) {
      border-bottom: 1px solid var(--color-border);
    }
  }
  &__value {
    width: 160px;
    height: 30px;

    display: flex;
    align-items: center;
    padding: 30px 30px;
  }
}
</style>